import React, { FC, ReactNode } from "react";

import { UserNavbar } from "@hl/shared-features/lib/features/auth/UserNavbar";
import { Navbar } from "@hl/shared-features/lib/features/layout/Navbar";
import useIsScrollTop from "@hl/shared-features/lib/hooks/useIsScrollTop";
import { Header, Group, Box } from "@mantine/core";

export type NavBarProps = {
  leftButtons?: ReactNode;
  extraButtons?: ReactNode;
  showBrand?: boolean;
  title?: ReactNode;
  isDashboard?: boolean;
};

export const AppHeader: FC<NavBarProps> = ({
  leftButtons,
  showBrand = true,
  isDashboard,
  title = null,
}) => {
  const { isScrollTop } = useIsScrollTop(isDashboard);

  const content = (
    <>
      <Box sx={{ alignSelf: "center" }}>{title}</Box>
      <UserNavbar />
    </>
  );
  return (
    <Header
      height={56}
      pl="lg"
      pr="xs"
      withBorder={!isScrollTop}
      sx={{
        boxSizing: "content-box",
      }}
    >
      <Group w="100%" h="100%" position="apart">
        {showBrand && !leftButtons && <Navbar>{content}</Navbar>}
        {(leftButtons || !showBrand) && (
          <>
            {leftButtons} {content}
          </>
        )}
      </Group>
    </Header>
  );
};
